import { render, staticRenderFns } from "./EnterCategoryForm.vue?vue&type=template&id=b9e10788&scoped=true&"
import script from "./EnterCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EnterCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e10788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
